import { render, staticRenderFns } from "./InstanceTab.vue?vue&type=template&id=e7b6a1f6&scoped=true&"
import script from "./InstanceTab.vue?vue&type=script&lang=js&"
export * from "./InstanceTab.vue?vue&type=script&lang=js&"
import style0 from "./InstanceTab.vue?vue&type=style&index=0&id=e7b6a1f6&lang=scss&scoped=true&"
import style1 from "./InstanceTab.vue?vue&type=style&index=1&id=e7b6a1f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7b6a1f6",
  null
  
)

export default component.exports